import React, { useState, useRef, useEffect } from 'react';
import ModalPortal from '../ModalPortal';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import classnames from 'classnames';
import VERTICAL_CONFIG from '../../constants/verticalConfig';
import './ModalShareLink.css';

const COPY_LINK_TIMEOUT = 3000;

function getDefaultVertical() {
  if (VERTICAL_CONFIG.IS_PASSPORT360_ENABLED) {
    return 'chubb_passport360';
  } else if (VERTICAL_CONFIG.IS_BOA_ENABLED) {
    return 'chubb_boa';
  } else {
    return 'N/A';
  }
}

function getShareUrlLink(brokerageSlug, brokerId, product) {
  const domain = window.location.host;
  const productSlug =
    product === 'chubb_boa' ? 'business-owners-accident' : 'passport360';
  return `https://${domain}/buy/${brokerageSlug}/${productSlug}?b=${brokerId}`;
}

function ModalShareLink({ broker, brokerageSlug, openModal }) {
  const [product, setProduct] = useState(getDefaultVertical());
  const [url, setUrl] = useState(
    getShareUrlLink(brokerageSlug, broker.id, getDefaultVertical())
  );
  const [isCopyLinkClicked, setIsCopyLinkedClicked] = useState(false);
  const modal = useRef(null);

  function handleUpdate({ target: { name, value } }) {
    setProduct(value);
    setUrl(getShareUrlLink(brokerageSlug, broker.id, value));
  }

  function handleCopyLink() {
    if (!isCopyLinkClicked) {
      setIsCopyLinkedClicked(true);
      setTimeout(() => {
        setIsCopyLinkedClicked(false);
      }, COPY_LINK_TIMEOUT);
    }
  }

  useEffect(
    function openModalOnLoad() {
      openModal(() => window.$(modal.current).modal('show'));
    },
    [openModal]
  );

  return (
    <ModalPortal>
      <div className="ModalShareLink modal" id="shareLinkModal" ref={modal}>
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content-wrapper">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Share link</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => window.$(modal.current).modal('hide')}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Please select the product you want to share.</p>
                <div className="ModalShareLink-divider form-group">
                  <label htmlFor="productSlug" className="text-uppercase">
                    Product
                  </label>
                  <select
                    className="form-control"
                    id="productSlug"
                    name="productSlug"
                    value={product || ''}
                    aria-required="true"
                    onChange={handleUpdate}
                  >
                    {VERTICAL_CONFIG.IS_PASSPORT360_ENABLED && (
                      <option value="chubb_passport360">Passport 360</option>
                    )}
                    {VERTICAL_CONFIG.IS_BOA_ENABLED && (
                      <option value="chubb_boa">Business Owner Accident</option>
                    )}
                  </select>
                </div>
                <div className="form-row">
                  <div className="form-group col-9">
                    <label htmlFor="url" className="text-uppercase">
                      COPY AND PASTE URL
                    </label>
                    <input
                      name="url"
                      id="url"
                      type="text"
                      value={url}
                      className="ModalShareLink-urlInput form-control"
                    />
                  </div>
                  <div className="form-group col-3 align-self-end">
                    <CopyToClipboard text={url}>
                      <button
                        data-testId="ModalShareLink_copyLinkButton"
                        onClick={handleCopyLink}
                        className={classnames('btn', {
                          'btn-complete': !isCopyLinkClicked,
                          'btn-success': isCopyLinkClicked,
                        })}
                      >
                        {isCopyLinkClicked ? 'Copied!' : 'Copy Link'}
                      </button>
                    </CopyToClipboard>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  onClick={() => window.$(modal.current).modal('hide')}
                  className="btn btn-complete"
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
}

export default ModalShareLink;
